<template>
  <div class="x-tablelist-view" data-automation="group">
    <!-- 搜索行 -->
    <ux-searchOption :layout="layout" :data="filter" @add="showAdd"></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        :emptyText="$t('HT.nodata')"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import addLimit from './template/addLimit';
export default {
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'button',
          text: this.$t('HT.appSendLimit.add'),
          hidden: !this.$hasModule(44),
          event: 'add'
        }
      ],
      columns: [
        // 表头数据
        {
          label: 'AppID',
          prop: 'app_id',
          tooltip: true
        },
        {
          label: this.$t('HT.appSendLimit.minute'),
          prop: 'minute',
          tooltip: true
        },
        {
          label: this.$t('HT.appSendLimit.day'),
          prop: 'day',
          tooltip: true
        },
        {
          label: this.$t('HT.addLimit.type'),
          prop: 'type',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return this.$opt.switchStr(cellValue, this.$opt.messageType);
          }
        },
        {
          label: this.$t('HT.apiStepOne.remark'),
          prop: 'memo',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(44),
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.edit2'), this.$t('HT.delete')],
                colors: ['#0087ff'],
                event: ['modify', 'del']
              },
              on: {
                del: () => {
                  const title = this.$t('HT.appSendLimit.del');
                  const content = this.$t('HT.appSendLimit.del.content');
                  this.$uxModal.show({
                    title,
                    content,
                    confirm: () => {
                      this.delList(params.id);
                    }
                  });
                },
                modify: () => {
                  const title = this.$t('HT.appSendLimit.edit');
                  this.$uxModal.show({
                    title,
                    content: (h) => {
                      return h(addLimit, {
                        props: {
                          data: params
                        }
                      });
                    },
                    confirm: (data) => {
                      this.modifyList(params.id, data);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        app_id: '', // APP-ID
        page: 1,
        size: 10,
        type: '' // 消息类型
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    this.getList(this.filter);
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.message.getLimitApp(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     */
    addLimit(params) {
      this.$uxLoading.show();
      this.$api.message.addLimitApp(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(id) {
      this.$uxLoading.show();
      this.$api.message.delLimitApp(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 修改列表
     * @param {Object} params 表单提交参数
     */
    modifyList(id, params) {
      this.$uxLoading.show();
      this.$api.message.changeLimitApp(id, params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess2'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 方法
     * @param {Object} params 查询对象
     */
    forDisable(params) {
      this.$api.system.disableAndstart(params.id, { disabled: !params.disabled }).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          params.disabled === true
            ? this.$uxMessage.success(this.$t('HT.addApi.disabledSuccess'))
            : this.$uxMessage.success(this.$t('HT.addApi.enabledSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 新建分组弹窗
     */
    showAdd() {
      const title = this.$t('HT.appSendLimit.add1');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addLimit);
        },
        confirm: (params) => {
          this.addLimit(params);
        }
      });
    },

    /**
     * 点击搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
